var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightBulbGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.87,
    height: 80.87,
    viewBox: "0 0 80.87 80.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BULB_LIGHT",
    "data-name": "BULB LIGHT",
    transform: "translate(18.148 20.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WRONG",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M49.573,27.282a22.238,22.238,0,0,1-8.5,17.51A10.688,10.688,0,0,0,37,51.19a.287.287,0,0,0-.159-.032h-19.1a.542.542,0,0,0-.223.032,9.687,9.687,0,0,0-3.629-6.112,22.287,22.287,0,1,1,35.688-17.8Z",
    transform: "translate(-4.999 -5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M28.413,19.532a9.414,9.414,0,0,0-.159,1.655v7.067a5.6,5.6,0,0,1-5.571,5.571H14.724c-2.674,0-5.571-2.037-5.571-6.494V21.7a9.8,9.8,0,0,0-.223-2.165.542.542,0,0,1,.223-.032h19.1a.287.287,0,0,1,.159.032Z",
    transform: "translate(3.585 26.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M25.714,24.275H11.388a2.388,2.388,0,0,1,0-4.775H25.714a2.388,2.388,0,0,1,0,4.775Z",
    transform: "translate(3.738 26.658)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M31.261,65.485H23.3c-2.684,0-5.571-2.037-5.571-6.507V53.362a10.321,10.321,0,0,0-3.849-8.293,22.284,22.284,0,1,1,27.168-.283,10.373,10.373,0,0,0-4.218,8.051v7.077A5.577,5.577,0,0,1,31.261,65.485ZM27.237,9.78a18.493,18.493,0,0,0-3.763.392,17.5,17.5,0,0,0-6.724,31.081A15.116,15.116,0,0,1,22.5,53.362v5.616c0,.29.038,1.732.8,1.732h7.959a.8.8,0,0,0,.8-.8V52.837A15.114,15.114,0,0,1,38.1,41.029,17.49,17.49,0,0,0,27.237,9.78Z",
    transform: "translate(-4.993 -5.001)",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1414",
    "data-name": "Rectangle 1414",
    transform: "translate(-18.148 -20.385)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.87,
    height: 80.87,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79.87,
    height: 79.87,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbGrey);
export default __webpack_public_path__ + "static/media/light-bulb-grey.c4d20932.svg";
export { ForwardRef as ReactComponent };